import { AppData, Log, Registry } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { Logger } from "./logger";
import { Helper } from "./helper";
import { Lifecycle } from "@firebolt-js/sdk";
import { PLATFORM } from "./enum";

export class FreeWheelAds {
  freeWheelAds = {
    player: null,
    currentAdObj: {},
    appName: "",
    currentAdContext: null,
    videoDuration: 0,
    currentSlot: null,
    prerollSlots: [],
    postrollSlots: [],
    midrollSlots: [],
    config: null,
    videoConfig: null,
    videoInfo: null,
    adSerialNo: 0,
    totalAdsInPod: 0,
    breakPosition:0,
    adActuallyPlayed: false,
    lastErrorAdId: null,
    prerollStatus: {},
    midrollStatus: {},
    multipleReq: true,
    vodContentStateSet: false,
    contentState: "",
    videoObj: null,
    adHandler: null,
    mainVideoPlayer: null,
    fallbackRequested:false,
    noAds:0,
    pfTime:0,
    isFusePF:false,
    lastEvent:null


    // #1 - Initialize the freewheel object
    initAds: function (shouldRequestAdNow, videoInfo, videoObj) {
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> initAds called...", "");
      this.videoInfo = videoInfo;
      this.videoObj = videoObj;
      if (!tv.freewheel.FTPlayer) {
        initTV();
      }

      const { appConfig, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      this.adHandler = app.adHandler;

      this.player = new tv.freewheel.FTPlayer(videoInfo);
      this.vodContentStateSet = false;
    },

    // #2 - Request ad playback for preroll or midroll
    checkAndPlayAds: function () {
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      //let adObj = app?.adObj;
      let ads = app?.ads;
      let freeWheelAds = app?.freeWheelAds;

      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> checkAndPlayAds called...",
        ""
      );
      if (appState.player.pausedTime !== 0) {
        freeWheelAds.adSerialNo = 0;
        if (freeWheelAds.player !== null) freeWheelAds.player.playMidroll();
      } else {
        freeWheelAds.adSerialNo = 0;
        freeWheelAds.mainVideoPlayer.pause(); // as going to request preroll, pausing video playback for now
        ads.preRollRequestMade = true;
      }
    },

    // Log all ad requests after successfull ad playback or any ad error
    logAd: function (adAvailable, adPlayed, adType, adObj, transactionId='') {
      var adDetails = {};
      adDetails.adProvider = "Comcast-Freewheel";
      adDetails.adProviderName = "Comcast-Freewheel";
      adDetails.adPriority = 0;
      adDetails.adAvailable = adAvailable;
      adDetails.adPlayed = adPlayed;
      adDetails.adType = adType;
      if (adObj.adId == undefined) {
        adDetails.adId = "";
      } else {
        adDetails.adId = adObj.adId;
      }
      if (adObj.adTitle == undefined) {
        adDetails.adTitle = "";
      } else {
        adDetails.adTitle = adObj.adTitle;
      }
      Logger.logAdView(adDetails,transactionId);
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      freeWheelAds.currentAdObj = {};
      freeWheelAds.lastErrorAdId = null;
    },

    requestAdsCustom: function (videoObj:any) {
      Logger.printLog("adlogfw", "FW >> requestAdsCustom called", "");
      this.videoObj = videoObj;
      const { appConfig, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let ads = app?.ads;
      ads.adscurrentController = 'freewheel';
      const videoInfo = app?.navigation.getCurrentVodInfo();
      tv.freewheel.FTPlayer.prototype.setupConfig(videoInfo);
      tv.freewheel.FTPlayer.prototype.requestAdConfig(videoInfo);
    },
    requestPrefetchAds: function (videoObj:any,pfTime:any) {
      Logger.printLog("adlogfw", "FW >> requestAdsCustom called", "");
      this.videoObj = videoObj;
      const { appConfig, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let ads = app?.ads;
      ads.adscurrentController = 'freewheel';
      const videoInfo = app?.navigation.getCurrentVodInfo();
      tv.freewheel.FTPlayer.prototype.setupConfig(videoInfo);
      tv.freewheel.FTPlayer.prototype.requestAdConfig(videoInfo);
    },
    requestFallbackIma: function(videoInfo:any, noAds:any, cuePointTime:any) {
      tv.freewheel.FTPlayer.prototype.requestFallbackIma(videoInfo, noAds, cuePointTime);
    }
  };
}
function initTV() {
  tv.freewheel = tv.freewheel || {};
  tv.freewheel.FTPlayer = function (videoInfo: any) {
    // Step #1: Obtain content metadata
    this.setupConfig(videoInfo);
    // Step #2: Initialize AdManager
    // Only one AdManager instance is needed for each player
    this.requestAdConfig(videoInfo);
  };

  tv.freewheel.FTPlayer.prototype = {
    setupConfig: function (videoInfo) {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      freeWheelAds.videoDuration = videoInfo.runtime;
      freeWheelAds.currentAdContext = null;
      freeWheelAds.currentSlot = null; // Used to keep track of current slot playing
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> setupConfig called...", "");
    },

    requestAdConfig: function (videoInfo) {
      const { appConfig } = AppData as AppSetup;
      //fwAdHelper.removeAdVideoElem();
      //fwAdHelper.createAdVideoElem();
      let testInfo = appConfig?.testInfo;
      if (testInfo.testAdFreewheel) {
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> requestAdConfig ...testAdMode enabled going to specific method",
          ""
        );
        this._test_requestAdConfig(videoInfo);
        return;
      }

      try {
        if(Lifecycle && Lifecycle.state){
        } else {
          this.playContent();
          return;
        }
      } catch(error) {
        Log.error("Lifecycle.state ",error)
      }
      
      var _this = this;
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      freeWheelAds.totalAdsInPod = 0;
      if (
        freeWheelAds.config == null ||
        freeWheelAds.config.adNetworkID == undefined
      ) {
        const { platform } = AppData as AppSetup;
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> requestAdConfig ... calling getAdConfig",
          ""
        );
        const appApiConfig = appState?.getAppApiConfig();
        const genre = appApiConfig?.appConfig?.genre;        
        let coppa;
        if (appConfig?.platform_id == PLATFORM.PLATCO) {
          coppa = false;   
          if(genre && genre.toLocaleLowerCase() !== "movies"){
            coppa = true;
          }       
        } else {
          coppa = "false";   
          if(genre && genre.toLocaleLowerCase() !== "movies"){
            coppa = "true";
          }
        }
        
        try {
          platform
            .getAdConfig({"environment":"prod","authenticationEntity":"MVPD", "coppa":coppa})
            .then((adConfig) => {
              Logger.printLog(
                "adlogfw",
                "FREEWHEEL ADS >>> requestAdConfig ... adConfig",
                adConfig
              );
              try {
                // Initialize AdManager. We only need one AdManager instance for the lifetime of the player

                if(adConfig.adNetworkId){
                  adConfig.adNetworkID = adConfig.adNetworkId;
                }

                if(adConfig.adProfileId){
                  adConfig.adProfileID = adConfig.adProfileId;
                }
                if(adConfig.adSiteSectionId){
                  adConfig.adSiteSectionID = adConfig.adSiteSectionId;
                }
                /*adConfig.adNetworkID = "392024";
                adConfig.adProfileID = "392024:x1_futuretoday";
                adConfig.adSiteSectionID = "futuretoday_testapp_publica";
                adConfig.coppa = adConfig.coppa.toString();
                adConfig.adServerUrl = "g1.v.fwmrm.net",*/
                adConfig.coppa = adConfig.coppa.toString();
                // END
                // Initialize AdManager. We only need one AdManager instance for the lifetime of the player
                //var videoInfo = freeWheelAds.videoInfo;
                freeWheelAds.config = adConfig;
                freeWheelAds.config.videoAssetId = 'futuretoday_00000';//appConfig.fwCaids[parseInt(appConfig.siteId)];JIRA XFIN-556

                _this.adManager = new tv.freewheel.SDK.AdManager(adConfig);
                _this.adManager.setNetwork(adConfig.adNetworkID);
                if(adConfig.adServerUrl.indexOf('https://') < 0 && adConfig.adServerUrl.indexOf('http://') < 0){
                  _this.adManager.setServer("https://" + adConfig.adServerUrl + "/ad/p/1");
                }

                freeWheelAds.videoConfig = {
                  mode: "on-demand",
                  duration: videoInfo.runtime||-1,
                  customID: videoInfo.node_id.toString(),
                  language: "en",
                  genre:
                    videoInfo.content_genre !== null
                      ? videoInfo.content_genre.split(",")[0]
                      : "",
                  brand: "FutureToday",
                  rating: videoInfo.age_appropriate_rating,
                  provider: "FutureToday",
                  title: "",
                  // 'series': '',
                  autoPlay: true,
                };
                freeWheelAds.currentAdContext = _this.adManager.newContext(
                  freeWheelAds.videoConfig,
                  "displayBase"
                );
                _this.configureAdRequest(videoInfo, adConfig);
              } catch (e) {
                Logger.printLog(
                  "error",
                  "FREEWHEEL ADS >>> requestAdConfig ... Error initializing AdManager:",
                  e
                );
                Logger.processUserAction(
                  "Freewheel_AdManagerInitObject_InitializationError_" + e
                );
                // Logic to handle error. We call onRequestComplete to enable content video playback without ads
                _this.onRequestComplete({
                  success: false,
                });
                // _this.playContent();
              }
            })
            .catch((e) => {
              Logger.printLog(
                "error",
                "FREEWHEEL ADS >>> requestAdConfig ... Error initializing AdManager:",
                e
              );
              Logger.processUserAction(
                "Freewheel_AdManagerInitObject_GetAdConfigDidNotRespond_" + e
              );
              // Logic to handle error. We call onRequestComplete to enable content video playback without ads
              _this.onRequestComplete({
                success: false,
              });
              // _this.playContent();
            });
        } catch (e) {
          Logger.printLog(
            "error",
            "FREEWHEEL ADS >>> requestAdConfig ... failed to respond:",
            e
          );
          Logger.processUserAction(
            "Firebolt_GetAdConfigDidNotRespond_" + e
          );
          _this.playContent();
        }
      } else if (freeWheelAds.config !== null) {
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> requestAdConfig ... using already initialized config",
          freeWheelAds.config
        );
        freeWheelAds.config.videoAssetId = 'futuretoday_00000';//appConfig.fwCaids[parseInt(appConfig.siteId)];JIRA XFIN-556
        _this.adManager = new tv.freewheel.SDK.AdManager(freeWheelAds.config);
        _this.adManager.setNetwork(freeWheelAds.config.adNetworkID);
        if(freeWheelAds.config.adServerUrl.indexOf('https://') < 0 && freeWheelAds.config.adServerUrl.indexOf('http://') < 0){
            _this.adManager.setServer("https://" + freeWheelAds.config.adServerUrl + "/ad/p/1");
        }

        freeWheelAds.currentAdContext = _this.adManager.newContext(freeWheelAds.videoConfig,"displayBase");
        _this.configureAdRequest(videoInfo, freeWheelAds.config);
      }
    },

    _test_requestAdConfig(videoInfo) {
      const { appConfig, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      freeWheelAds.config = {
        adNetworkID: "392024", // comcast test value
        // adNetworkID: "392025",
        adProfileID: "392024:x1_futuretoday",
        adServerUrl: "g1.v.fwmrm.net", // comcast test value
        // adServerUrl: "5fb59.v.fwmrm.net",
        adSiteSectionID: "futuretoday_testapp_publica", // comcast test value
        // adSiteSectionID: "comcast_futuretoday_fawesomescifi",
        appBundleID: "future_today_sci_fi_movies_tv_by_fawesome.Comcast",
        appName: "future_today_sci_fi_movies_tv_by_fawesome",
        coppa: "0",
        distributorAppID: "1001",
        ifa: "eyJ2YWx1ZSI6IjU1NDhiMzExLWZiN2EtNGI2My1iNWQ1LTcwYjg0MjdlNDc0YiIsImlmYV90eXBlIjoic3NwaWQiLCJsbXQiOiIwIn0=",
        ifaValue: "5548b311-fb7a-4b63-b5d5-70b8427e474b",
        privacyData:
          "eyJ1c19wcml2YWN5IjoiMS1OLSIsInBkdCI6ImdkcDp2MSIsImxtdCI6IjAifQ==",
        videoAssetId: "futuretoday_00000",
      };
      var _this = this;
      // var videoInfo = freeWheelAds.videoInfo;
      var adConfig = freeWheelAds.config;
      // freeWheelAds.config.videoAssetId = appConfig.fwCaids[parseInt(appConfig.siteId)];

      _this.adManager = new tv.freewheel.SDK.AdManager(adConfig);
      _this.adManager.setNetwork(adConfig.adNetworkID);
      _this.adManager.setServer("https://" + adConfig.adServerUrl + "/ad/g/1");
      //this.adManager.setServer('http://localhost/lightning-test/freewheel-ads/2ads.js');
      //this.adManager.setServer('http://localhost/freewheel/7-7-25-ads.js');


      if (appConfig.consoleDebugLog == true) {
        tv.freewheel.SDK.setLogLevel(tv.freewheel.SDK.LOG_LEVEL_DEBUG);
      } else {
        tv.freewheel.SDK.setLogLevel(tv.freewheel.SDK.LOG_LEVEL_QUIET);
      }

      //fwAdHelper.removeAdVideoElem();

      //fwAdHelper.createAdVideoElem();

      freeWheelAds.videoConfig = {
        mode: "on-demand",
        duration: videoInfo.runtime,
        customID: videoInfo.node_id.toString(),
        language: "en",
        genre:
          videoInfo.content_genre !== null
            ? videoInfo.content_genre.split(",")[0]
            : "",
        brand: "FutureToday",
        rating: videoInfo.age_appropriate_rating,
        provider: "FutureToday",
        title: "",
        // 'series': '',
        autoPlay: true,
      };
      freeWheelAds.currentAdContext = _this.adManager.newContext(
        freeWheelAds.videoConfig,
        "displayBase"
      );
      _this.configureAdRequest(videoInfo, adConfig);
    },

    configureAdRequest: function (videoInfo, adConfig) {
      const { appConfig, appState } = AppData as AppSetup;
      let testInfo = appConfig?.testInfo;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      // Saving content src to play after the preroll finishes
      freeWheelAds.currentAdContext.setProfile(freeWheelAds.config.adProfileID);
      freeWheelAds.currentAdContext.setVideoAsset(
        freeWheelAds.config.videoAssetId,
        freeWheelAds.videoDuration
      );
      freeWheelAds.currentAdContext.setSiteSection(
        freeWheelAds.config.adSiteSectionID
      );
      // Setting larger timeouts for testing on VPN - can be removed later
      if (testInfo.testAdTimeout) {
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_VPAID_CREATIVE_TIMEOUT_DELAY,
          50000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_RENDERER_HTML_AD_LOAD_TIMEOUT,
          50000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_START_DETECT_TIMEOUT,
          50000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_VAST_TIMEOUT_IN_MILLISECONDS,
          50000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_PROGRESS_DETECT_TIMEOUT,
          50000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
      } else {
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_VPAID_CREATIVE_TIMEOUT_DELAY,
          10000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_RENDERER_HTML_AD_LOAD_TIMEOUT,
          10000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_START_DETECT_TIMEOUT,
          10000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_VAST_TIMEOUT_IN_MILLISECONDS,
          10000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
        freeWheelAds.currentAdContext.setParameter(
          tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_PROGRESS_DETECT_TIMEOUT,
          10000,
          tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
        );
      }
      // Turn off ad click for Flex
      freeWheelAds.currentAdContext.setParameter(
        "renderer.video.clickDetection",
        false,
        tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL
      );
      // Setting up bindings
      this.onRequestComplete = this.onRequestComplete.bind(this);
      this.onSlotEnded = this.onSlotEnded.bind(this);
      this.onAdEvent = this.onAdEvent.bind(this);
      // Step #3: Configure ad request
      this.requestAds(videoInfo, adConfig);
    },

    requestAds: function (videoInfo, adConfig) {
      const { appConfig, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;
      let ads = app?.ads;
      let freeWheelAds = app?.freeWheelAds;

      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> requestAds called with videoInfo: ",
        videoInfo
      );
      if (freeWheelAds.currentAdContext == null) return;
      // Step #3: Configure ad request
      freeWheelAds.prerollSlots = [];
      freeWheelAds.postrollSlots = [];
      freeWheelAds.midrollSlots = [];

      // Add preroll
      //|| true
      if (
        fwAdHelper.checkIfPreRollBeRequested() &&
        appState.player.pausedTime == 0
      ) {
        var j = 0;
        if (appConfig.enableAdPodding == true) {
          for (var j = 0; j < adObj.nonmidrollsize; j++) {
            freeWheelAds.currentAdContext.addTemporalSlot(
              "Preroll-" + j,
              tv.freewheel.SDK.ADUNIT_PREROLL,
              0,
              "",
              0,
              30,
              0,
              "video/mp4",
              "",
              adObj.nonmidrollsize
            );
          }
        } else {
          freeWheelAds.currentAdContext.addTemporalSlot(
            "Preroll-" + j,
            tv.freewheel.SDK.ADUNIT_PREROLL,
            0,
            "",
            0,
            30,
            0,
            "video/mp4",
            "",
            adObj.nonmidrollsize
          );
        }
      }
      // Add midroll
      var midrollAdMax = appConfig.midrollAdMax;
      if(freeWheelAds.breakPosition==1){
        const appApiConfig = appState?.getAppApiConfig();
        midrollAdMax = Number(appApiConfig?.appConfig?.firstmidrollsize);                
      }
      if (freeWheelAds.multipleReq == false) {
        ads.currentVodCuePoints.forEach(function (i, val) {
          var j = 0;
          if (appConfig.enableAdPodding == true) {
            for (var j = 0; j < midrollAdMax; j++) {
              freeWheelAds.currentAdContext.addTemporalSlot(
                "Midroll-" + i + "-" + j,
                tv.freewheel.SDK.ADUNIT_MIDROLL,
                val,
                "",
                0,
                appConfig.maxTotalAdDuration,
                0,
                "video/mp4",
                "",
                midrollAdMax
              );
            }
          } else {
            freeWheelAds.currentAdContext.addTemporalSlot(
              "Midroll-" + i + "-" + j,
              tv.freewheel.SDK.ADUNIT_MIDROLL,
              val,
              "",
              0,
              appConfig.maxTotalAdDuration,
              0,
              "video/mp4",
              "",
              midrollAdMax
            );
          }
        });
      } else if (appState.player.pausedTime !== 0) {
        freeWheelAds.currentAdContext.addTemporalSlot(
          "Midroll",
          tv.freewheel.SDK.ADUNIT_MIDROLL,
          appState.player.pausedTime,
          "",
          0,
          appConfig.maxTotalAdDuration,
          0,
          "video/mp4",
          "",
          midrollAdMax
        );
      }

      this.setupMacros(videoInfo, adConfig);

      // Turn off sltp value for purposes of testing on the CCX ad server
      freeWheelAds.currentAdContext.setCapability(
        tv.freewheel.SDK.CAPABILITY_SLOT_TEMPLATE,
        tv.freewheel.SDK.CAPABILITY_STATUS_OFF
      );

      var el = document.getElementById("displayBase");

      // Let context object knows where to render the ad
      var displayBaseId = "displayBase";
      freeWheelAds.currentAdContext.registerVideoDisplayBase(displayBaseId);

      // Listen to AdManager Events
      freeWheelAds.currentAdContext.addEventListener(
        tv.freewheel.SDK.EVENT_REQUEST_COMPLETE,
        this.onRequestComplete
      );
      freeWheelAds.currentAdContext.addEventListener(
        tv.freewheel.SDK.EVENT_SLOT_END,
        this.onSlotEnd
      );
      freeWheelAds.currentAdContext.addEventListener(
        tv.freewheel.SDK.EVENT_SLOT_ENDED,
        this.onSlotEnded
      );
      freeWheelAds.currentAdContext.addEventListener(
        tv.freewheel.SDK.EVENT_SLOT_STARTED,
        this.onSlotStarted
      );
      freeWheelAds.currentAdContext.addEventListener(
        tv.freewheel.SDK.EVENT_AD,
        this.onAdEvent
      );
      freeWheelAds.currentAdContext.addEventListener(
        tv.freewheel.SDK.EVENT_TYPE_ERROR,
        this.onAdEventError
      );

      tv.freewheel.SDK.AdListener.prototype.onError = function (errorMessage) {
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> onAdEventError fired",
          ""
        );
        Logger.processUserAction("Freewheel_AdError_" + errorMessage);
      };

      // Step #4: Submit ad request
      // && false
      if (
        !fwAdHelper.checkIfPreRollBeRequested() &&
        appState.player.pausedTime == 0
      ) {
        this.playContent(false);
      } else {
        freeWheelAds.currentAdContext.submitRequest(10);
      }

      // Store corresponding content video state (PLAYING, COMPLETED, PAUSED)
      freeWheelAds.contentState = "";
    },

    setupMacros: function (videoInfo, adConfig) {
      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> setupMacros called...adConfig - ",
        [adConfig, videoInfo]
      );
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;
      let ads = app?.ads;
      let freeWheelAds = app?.freeWheelAds;
      var blankStr = "";
      var ua = navigator.userAgent;
      var dm = platform?.getFullModel();
      if (platform?.getFullModel().indexOf("_") !== -1) {
        dm = dm.split("_")[1];
      }
      // var ftUserAgent = helper.fixedEncodeURIComponent(encodeURI(ua + ', X1_STB_/1.0.0.0 (X1, ' + dm + ', )'));
      //var ftUserAgent = ua + ", X1_STB_/1.0.0.0 (X1, " + dm + ", )";
      var ftUserAgent = navigator.userAgent;
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_player_height",
        window.screen.height.toString()
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_player_width",
        window.screen.width.toString()
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_h_user_agent",
        ftUserAgent
      );
      if (appState.player.vodAutoPlayed) {
        var cntPlay = 1;
        freeWheelAds.currentAdContext.addKeyValue(
          "_fw_continuous_play",
          cntPlay.toString()
        );
        appState.player.vodAutoPlayed = false;
      } else {
        freeWheelAds.currentAdContext.addKeyValue(
          "_fw_continuous_play",
          "0"
        );
      }
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_content_id",
        videoInfo.node_id.toString()
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_content_genre",
        videoInfo.primary_genre
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_content_rating",
        videoInfo.age_appropriate_rating
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_fw_content_title",
        ""
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_ft_content_producer",
        videoInfo.author
      );
      freeWheelAds.currentAdContext.addKeyValue(
        "_ft_content_cat",
        videoInfo.primary_category
      );
      if (videoInfo.episode !== null)
        freeWheelAds.currentAdContext.addKeyValue(
          "_ft_content_episode",
          ""
        );
      if (videoInfo.season !== null)
        freeWheelAds.currentAdContext.addKeyValue(
          "_ft_content_series",
          ""
        );
    },

    // Step #4: Listen for ad request completed and set all slot variables
    onRequestComplete: function (event) {
      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> onRequestComplete - AD REQUEST COMPLETE",
        event
      );

      
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      freeWheelAds.lastEvent = event;
      if (appState.videoMode == false) return;
      // After request completes, store each roll in corresponding slot array
      if (event.success) {
        var temporalSlots = freeWheelAds.currentAdContext.getTemporalSlots();
        for (var i = 0; i < temporalSlots.length; i++) {
          var slot = temporalSlots[i];
          var slotTimePositionClass = slot.getTimePositionClass();
          if (
            slotTimePositionClass ==
            tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL
          ) {
            freeWheelAds.prerollSlots.push(slot);
          } else if (
            slotTimePositionClass ==
            tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL
          ) {
            freeWheelAds.midrollSlots.push(slot);
          } else if (
            slotTimePositionClass ==
            tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL
          ) {
            freeWheelAds.postrollSlots.push(slot);
          }
        }
        this.checkForImaFallback();
      } else {
        if (
          !fwAdHelper.checkIfPreRollBeRequested() &&
          appState.player.pausedTime == 0
        ) {
          this.playContent();
          return;
        }        
        this.checkForImaFallback();        
      }
    },

    checkForImaFallback:function(){      
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      var temporalSlots = freeWheelAds.currentAdContext.getTemporalSlots();
      var slot = temporalSlots[temporalSlots.length-1];

      if (
        freeWheelAds.multipleReq == true &&
        appState.player.pausedTime !== 0
      ) {          
        Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> onRequestComplete : enableWaterfalling : enableAdCountCheck',[appConfig.enableWaterfalling,' : ',appConfig.enableAdCountCheck]);          
        if(appConfig.enableWaterfalling == true) {
          freeWheelAds.fallbackRequested=false;
          freeWheelAds.noAds=0;
          Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> 1. freeWheelAds - noAds',[freeWheelAds.noAds]);          
          var _duration = 0;
          var adCount = 0;
          if(slot){
            if(slot.getTotalDuration()){
              _duration = slot.getTotalDuration();
            }
            if(slot.getAdCount()){
              adCount = slot.getAdCount();
            }
          }
          if(appConfig.skipHlsFromFreewheel){
            var newAdCount=0;
            if(slot && slot.getAdInstances() && slot.getAdInstances().length>0){
              for(var i=0;i<slot.getAdInstances().length;i++){
                var _mimeType = slot.getAdInstances()[i]._primaryCreativeRendition._primaryCreativeRenditionAsset._mimeType;
                Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> _mimeType ', [_mimeType]);
                if(_mimeType!='application/x-mpegURL'){
                  newAdCount++;
                }              
              }
            }
            adCount=newAdCount;
            _duration=newAdCount*appConfig.durationPerAd;
          }
          Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> MIDROLL getTotalDuration ', [_duration]);
          Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> MIDROLL getAdCount ', [adCount]);
          var diff = appConfig.maxTotalAdDuration - _duration;
          var noOfAds = 0;
          if(diff>=appConfig.durationPerAd){
            if(appConfig.enableAdCountCheck){
              //no need to use this var - maxTotalAdCount as it is duplicate of midrollAdMax
              //noOfAds = appConfig.maxTotalAdCount - adCount;
              var midrollAdMax = appConfig.midrollAdMax;
              if(freeWheelAds.breakPosition==1){
                const appApiConfig = appState?.getAppApiConfig();
                midrollAdMax = Number(appApiConfig?.appConfig?.firstmidrollsize);                
              }
              noOfAds = midrollAdMax - adCount;              
              if(noOfAds>0){
                var cuePointTime = appState.player.pausedTime;
                if(appConfig.prefetchAds){
                  cuePointTime = cuePointTime + appConfig.prefetchTiming;
                }
                if(freeWheelAds.isFusePF){                  
                  freeWheelAds.noAds = noOfAds;
                  Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> 2. freeWheelAds - noAds',[freeWheelAds.noAds]);          
                  app.imaAdHandler.requestFusePrefetch(freeWheelAds.videoInfo, noOfAds, cuePointTime);
                } else {
                  this.requestFallbackIma(freeWheelAds.videoInfo, noOfAds, cuePointTime);
                }
              }
            } else {
              noOfAds = Math.ceil(diff/appConfig.durationPerAd)
              var cuePointTime = appState.player.pausedTime;
              if(appConfig.prefetchAds){
                cuePointTime = cuePointTime + appConfig.prefetchTiming;
              }
              if(freeWheelAds.isFusePF){
                freeWheelAds.noAds = noOfAds;  
                Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> 3. freeWheelAds - noAds',[freeWheelAds.noAds]);          
                app.imaAdHandler.requestFusePrefetch(freeWheelAds.videoInfo, noOfAds, cuePointTime);
              } else {
                this.requestFallbackIma(freeWheelAds.videoInfo, noOfAds, cuePointTime);
              }
            }
          }
        }




        if(appConfig.prefetchAds == false) {
          this.playMidroll();
        }
      } else {
        var _duration = 0;
        var adCount = 0;
        if(slot){
          if(slot.getTotalDuration()){
            _duration = slot.getTotalDuration();
          }
          if(slot.getAdCount()){
            adCount = slot.getAdCount();
          }
        }

        if(appConfig.skipHlsFromFreewheel){
          var newAdCount=0;
          if(slot && slot.getAdInstances() && slot.getAdInstances().length>0){
            for(var i=0;i<slot.getAdInstances().length;i++){
              var _mimeType = slot.getAdInstances()[i]._primaryCreativeRendition._primaryCreativeRenditionAsset._mimeType;
              Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> _mimeType ', [_mimeType]);
              if(_mimeType!='application/x-mpegURL'){
                newAdCount++;
              }              
            }
          }
          adCount=newAdCount;
          _duration=newAdCount*appConfig.durationPerAd;
        }

        Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> PREROLL getTotalDuration ', [_duration]);
        Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> PREROLL getAdCount ', [adCount]);
        if(appConfig.enableWaterfalling == true) {
          freeWheelAds.fallbackRequested=false;
          freeWheelAds.noAds=0;
          Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> 4. freeWheelAds - noAds',[freeWheelAds.noAds]);          
          if(_duration<=0){
            var noOfAds = 1;
            var cuePointTime = appState.player.pausedTime;
            this.requestFallbackIma(freeWheelAds.videoInfo, noOfAds, cuePointTime);
          }
        }
        this.playPreroll();
      }

    },

    requestFallbackIma: function(videoInfo, noAds, cuePointTime) {
      Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> requestFallbackIma noAds ', [noAds]);
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;
      if(adObj && adObj.adsdklist && adObj.adsdklist.length>0){       
        let freeWheelAds = app?.freeWheelAds;
        freeWheelAds.fallbackRequested=true;
        freeWheelAds.noAds = noAds;
        Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> 5. freeWheelAds - noAds',[freeWheelAds.noAds]);          
        if(appState.player.pausedTime!=0){
          app.imaAdHandler.requestFallback(videoInfo, noAds, cuePointTime);
        } else {
          app.imaAdHandler.requestFallbackPreroll(videoInfo, noAds, cuePointTime);
        }
      }
    },

    passControlToIma: function(setstate) {
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let ads = app?.ads;
      ads.adscurrentController = 'ima';
      if(app.imaAdHandler.cuePointsManager){
        //app.imaAdHandler.cuePointsManager.hitRequestTrackers(appState.player.pausedTime);
        app.imaAdHandler.cuePointsManager.updateCurrentTime(appState.player.pausedTime);
      } else {
        //content resume
        this.handlePlayContent(setstate);
      }
      return;
    },

    onAdEvent: function (event) {
      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> onAdEvent - AD EVENT DETAILS - ",
        event
      );
      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> onAdEvent - Ad event: " +
          event.subType +
          " with ad:" +
          event.adInstance.getAdId() +
          " and slot:" +
          event.slot.getCustomId() +
          " creative duration:" +
          event.adInstance.getDuration(),
        ""
      );

      var adInstance = event.adInstance;
      var slot = event.slot;
      var slotTimePositionClass = slot.getTimePositionClass();

      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      let ads = app?.ads;

      switch (event.subType) {
        case tv.freewheel.SDK.EVENT_AD_PREINIT:
          //playbarOptions.forceHidePlayerControls();
          freeWheelAds.adHandler.setAdState();
          //freeWheelAds.mainVideoPlayer.removeAttribute('crossorigin');
          break;

        case tv.freewheel.SDK.EVENT_AD_INITIATED:
          var _mimeType = freeWheelAds.currentSlot.getCurrentAdInstance().getActiveCreativeRendition()._primaryCreativeRenditionAsset._mimeType;
          var adIdd = adInstance.getAdId();          
          Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> _mimeType : ', [_mimeType]);
          if(_mimeType=='application/x-mpegURL'){
            try{              
              /*var lastAdId = freeWheelAds.currentSlot.getAdInstances()[freeWheelAds.currentSlot.getAdInstances().length-1].getAdId();
              Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> adId : lastAdId ', [adIdd, lastAdId]);              
              if(adIdd == lastAdId){
                freeWheelAds.currentSlot.stop ();
              } else {
              }*/
              freeWheelAds.currentSlot.skipCurrentAd ();
            } catch(e){        
                Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> catch ', [e]);              
            }
            return;
          }
          // ad started
          // Populate adDetails obj

          var adName =
            adInstance.getActiveCreativeRendition()
              ._primaryCreativeRenditionAsset._name;
          /*if(!adName){
            adName='';
          }*/
          var adContentType = adInstance
            .getActiveCreativeRendition()
            ._primaryCreativeRenditionAsset._contentType.replace("/", "-");
          var adId = adInstance.getAdId();
          var adUrl =
            adInstance.getActiveCreativeRendition()
              ._primaryCreativeRenditionAsset._url;
          if(adUrl){
            adUrl = encodeURIComponent(adUrl);
          }

          freeWheelAds.currentAdObj.adId = adId;
          freeWheelAds.currentAdObj.adTitle =
            "adDuration_" +
            event.adInstance.getDuration() +
            "_name_" +
            adName +
            "_type_" +
            adContentType +
            "_url_" +
            adUrl;
          freeWheelAds.adActuallyPlayed = false;

          if (
            slotTimePositionClass ==
            tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL
          ) {
            freeWheelAds.prerollStatus.initCount++;
          } else {
            freeWheelAds.midrollStatus.initCount++;
          }
          ads.adsPlayedTime += event.adInstance.getDuration();
          break;

        case tv.freewheel.SDK.EVENT_AD_SKIPPED:          
          Logger.processUserAction('adSkipped');
          break;

        case tv.freewheel.SDK.EVENT_AD_IMPRESSION:
          if (freeWheelAds.currentSlot !== null) {
            freeWheelAds.adSerialNo++;
            freeWheelAds.totalAdsInPod = freeWheelAds.currentSlot.getAdCount();
            const { appConfig } = AppData as AppSetup;

            if(appConfig.skipHlsFromFreewheel){
              var newAdCount=0;
              var slot = freeWheelAds.currentSlot;
              if(slot && slot.getAdInstances() && slot.getAdInstances().length>0){
                for(var i=0;i<slot.getAdInstances().length;i++){
                  var _mimeType = slot.getAdInstances()[i]._primaryCreativeRendition._primaryCreativeRenditionAsset._mimeType;
                  Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> _mimeType ', [_mimeType]);
                  if(_mimeType!='application/x-mpegURL'){
                    newAdCount++;
                  }              
                }
              }
              freeWheelAds.totalAdsInPod=newAdCount;              
            }
            Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> adSerialNo totalAdsInPod ', [freeWheelAds.adSerialNo,freeWheelAds.totalAdsInPod]);
            if (freeWheelAds.adSerialNo > freeWheelAds.totalAdsInPod) {
              freeWheelAds.adSerialNo = freeWheelAds.totalAdsInPod;
            }
            if (freeWheelAds.adSerialNo == 0) {
              fwAdHelper.showHideAdLabel("hide");
            } else {
              fwAdHelper.showHideAdLabel("show");
            }
            Logger.printLog("adlogfw", "FW TEST AD", [
              freeWheelAds.adSerialNo,
              freeWheelAds.totalAdsInPod,
            ]);
          }
          Helper.preloaderDisplay("hide");
          try{
            freeWheelAds.videoObj.hideLoader();
          } catch(e){
          }
          break;

        case tv.freewheel.SDK.EVENT_AD_FIRST_QUARTILE:
          freeWheelAds.adActuallyPlayed = true;
          freeWheelAds.videoObj.removeEventListeners(); //just in case if it was not removed earlier
          break;

        case tv.freewheel.SDK.EVENT_AD_COMPLETE:
          // if(appState.player.pausedTime !== 0) freeWheelAds.logAd(true, true, 'midroll', freeWheelAds.currentAdObj);
          break;

        case tv.freewheel.SDK.EVENT_AD_IMPRESSION_END:
          if (
            slotTimePositionClass ==
            tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL
          ) {
            freeWheelAds.prerollStatus.completeCount++;
            freeWheelAds.logAd(
              true,
              true,
              "preroll",
              freeWheelAds.currentAdObj
            );
          } else {
            freeWheelAds.midrollStatus.completeCount++;
            freeWheelAds.logAd(
              true,
              true,
              "midroll",
              freeWheelAds.currentAdObj
            );
          }
          break;

        case tv.freewheel.SDK.EVENT_ERROR:
          var errorCode = event[tv.freewheel.SDK.INFO_KEY_ERROR_CODE];
          var errorInfo = event[tv.freewheel.SDK.INFO_KEY_ERROR_INFO];
          var errorModule = event[tv.freewheel.SDK.INFO_KEY_ERROR_MODULE];

          // freeWheelAds.lastErrorAdId = '_adError_CODE_' + errorCode + '_INFO_' + errorInfo + '_MODULE_' + errorModule.replace(/\D/g,'');
          freeWheelAds.lastErrorAdId =
            "_adError_CODE_" + errorCode + "_INFO_" + errorInfo;

          break;

        case tv.freewheel.SDK.EVENT_AD_FIRST_QUARTILE:
          break;
      }
    },

    // Step #5: Add event listener for onSlotEnded
    onSlotEnded: function (event) {      
      Logger.printLog(
        "adlogfw",
        "FREEWHEEL ADS >>> onSlotEnded - event.slot.AdCount: ",
        event.slot.getAdCount()
      );
      const { appConfig, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;


      /*
      const app = appState?.getApp();
      let ads = app?.ads;
      ads.adscurrentController = 'ima';
      if(app.imaAdHandler.cuePointsManager){
      */

      let freeWheelAds = app?.freeWheelAds;

      if(event.slot.getAdCount()>0){
        Logger.processUserAction('adEnd');
      }

      var slotTimePositionClass = event.slot.getTimePositionClass();
      if (
        slotTimePositionClass == tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL
      ) {
        // var diff = freeWheelAds.prerollStatus.initCount - freeWheelAds.prerollStatus.completeCount;
        var diff =
          adObj.nonmidrollsize - freeWheelAds.prerollStatus.completeCount;
        if (diff > 0) {
          // log for ads where there was an unknown error
          var cuePoint = null;
          var transactionId = '';
          try {
            if(app && app.imaAdHandler && app.imaAdHandler.cuePointsManager && app.imaAdHandler.cuePointsManager.getCuePoint(appState.player.pausedTime)){
              cuePoint = app.imaAdHandler.cuePointsManager.getCuePoint(appState.player.pausedTime);
            }
          } catch(e){

          }
          if(appConfig?.enableIMAAdPodding) {
            if(cuePoint && cuePoint.adsManagerList && cuePoint.adsManagerList.length>0){
              if(cuePoint.adsManagerList[0] && cuePoint.adsManagerList[0].guid && cuePoint.adsManagerList[0] && cuePoint.adsManagerList[0].guid){
                transactionId = cuePoint.adsManagerList[0].guid;
              }
            }          
            for (var k = 0; k < diff; k++) {
              freeWheelAds.currentAdObj.adTitle = freeWheelAds.lastErrorAdId;
              freeWheelAds.logAd(
                false,
                false,
                "preroll",
                freeWheelAds.currentAdObj,
                transactionId[k]
              );
            }
          } else {
            if(cuePoint && cuePoint.adsManagerList && cuePoint.adsManagerList.length>0){
              if(cuePoint.adsManagerList[0] && cuePoint.adsManagerList[0].guid){
                transactionId = cuePoint.adsManagerList[0].guid;
              }
            }          
            for (var k = 0; k < diff; k++) {
              freeWheelAds.currentAdObj.adTitle = freeWheelAds.lastErrorAdId;
              freeWheelAds.logAd(
                false,
                false,
                "preroll",
                freeWheelAds.currentAdObj,
                transactionId
              );
            }
          }          
        }
      } else if (
        slotTimePositionClass == tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL
      ) {
        var midrollAdMax = appConfig.midrollAdMax;
        if(freeWheelAds.breakPosition==1){
          const appApiConfig = appState?.getAppApiConfig();
          midrollAdMax = Number(appApiConfig?.appConfig?.firstmidrollsize);                
        }
        var diff = midrollAdMax - freeWheelAds.midrollStatus.completeCount;
        if (diff > 0) {
          // log for ads where there was an unknown error
          var cuePoint = null;
          var transactionId = '';
          try {
            if(app && app.imaAdHandler && app.imaAdHandler.cuePointsManager && app.imaAdHandler.cuePointsManager.getCuePoint(appState.player.pausedTime)){
              cuePoint = app.imaAdHandler.cuePointsManager.getCuePoint(appState.player.pausedTime);
            }
          } catch(e){

          }
          if(appConfig?.enableIMAAdPodding) {
            for (var k = 0; k < diff; k++) {
              transactionId = ''
              if(cuePoint && cuePoint.adsManagerList && cuePoint.adsManagerList.length>0){
                if(cuePoint.adsManagerList[0] && cuePoint.adsManagerList[0].guid && cuePoint.adsManagerList[0].guid[k]){
                  transactionId = cuePoint.adsManagerList[0].guid[k];
                }
              }
              freeWheelAds.currentAdObj.adTitle = freeWheelAds.lastErrorAdId;
              freeWheelAds.logAd(
                false,
                false,
                "midroll",
                freeWheelAds.currentAdObj,
                transactionId
              );
            }            
          } else {
            for (var k = 0; k < diff; k++) {
              transactionId = ''
              if(cuePoint && cuePoint.adsManagerList && cuePoint.adsManagerList.length>0){
                if(cuePoint.adsManagerList[k] && cuePoint.adsManagerList[k].guid){
                  transactionId = cuePoint.adsManagerList[k].guid;
                }
              }
              freeWheelAds.currentAdObj.adTitle = freeWheelAds.lastErrorAdId;
              freeWheelAds.logAd(
                false,
                false,
                "midroll",
                freeWheelAds.currentAdObj,
                transactionId
              );
            }

          }
          
        }
      }
      freeWheelAds.player.playContent();
    },

    onSlotEnd: function () {
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> onSlotEnd fired", "");
    },

    onSlotStarted: function (e) {
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> onSlotStarted fired", e);
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;

      var adCount = 0;
      if (
        freeWheelAds.currentSlot !== undefined &&
        freeWheelAds.currentSlot !== null
      )
        adCount = freeWheelAds.currentSlot.getAdCount();
      if (adCount > 0) freeWheelAds.player.onAdStart();
      else {
        // fwAdHelper.updateAdLabel(null, null, 'Loading Advertisement...');
        // fwAdHelper.showHideAdLabel('show');
      }
    },

    onAdEventError: function () {
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> onAdEventError fired", "");
      Logger.processUserAction("Freewheel_AdError_");
    },

    playPreroll: function () {
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> playPreroll called...", "");
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;
      let ads = app?.ads;
      let freeWheelAds = app?.freeWheelAds;

      // Play preroll slot and then remove the played slot from preroll slot array
      if (freeWheelAds.prerollSlots.length > 0) {
        freeWheelAds.prerollStatus.initCount = 0;
        freeWheelAds.prerollStatus.completeCount = 0;
        freeWheelAds.currentSlot = freeWheelAds.prerollSlots.shift();
        var adCount = freeWheelAds.currentSlot.getAdCount();
        if (adCount > 0) {
          Logger.printLog(
            "adlogfw",
            "FREEWHEEL ADS >>> playPreroll - VALID instance found, trying to play",
            ""
          );
        } else {
          Logger.printLog(
            "adlogfw",
            "FREEWHEEL ADS >>> playPreroll - no valid preroll found",
            ""
          );
        }
        freeWheelAds.currentSlot.play();
      } else {
        // When there are no more preroll slots to play, play content
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> playPreroll - No slots found, playing content now",
          ""
        );
        freeWheelAds.currentAdObj.adTitle = "_adError_NO_AD_CREATIVE_FOUND";
        for (var k = 0; k < adObj.nonmidrollsize; k++) {
          freeWheelAds.logAd(
            false,
            false,
            "preroll",
            freeWheelAds.currentAdObj
          );
        }
        ads.preRollRequestMade = false;
        this.onAdStop();
        this.playContent();
      }
    },

    playMidroll: function () {
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;
      let freeWheelAds = app?.freeWheelAds;

      if (freeWheelAds.midrollSlots.length == 0) {
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> no midrolls slots found",
          ""
        );
        //fwAdHelper.removeAdVideoElem();
        this.playContent();
        return;
      }

      var videoCurrentTime = appState.player.pausedTime;
      freeWheelAds.midrollStatus.initCount = 0;
      freeWheelAds.midrollStatus.completeCount = 0;
      for (var i = 0; i < freeWheelAds.midrollSlots.length; i++) {
        var midrollSlot = freeWheelAds.midrollSlots[i];
        var slotTimePosition = midrollSlot.getTimePosition();
        var adId = midrollSlot.getCustomId();

        if(appConfig.prefetchAds == true) {
          slotTimePosition = slotTimePosition + appConfig.prefetchTiming;
        }

        Logger.printLog(
              "adlogfw",
              "FREEWHEEL ADS >>> playMidroll - videoCurrentTime: slotTimePosition " +
                videoCurrentTime +
                " : " +
                slotTimePosition,
              ""
            );
        if (videoCurrentTime == slotTimePosition) {
          // check if same slot as paused time
          if (midrollSlot.getAdCount() > 0) {
            // checks whether a valid ad exists
            Logger.printLog(
              "adlogfw",
              "FREEWHEEL ADS >>> playMidroll - VALID ad at slot: " +
                i +
                ", slotTimePosition: " +
                slotTimePosition,
              ""
            );

            this.pauseContent();

            // this.onAdStart();
            freeWheelAds.currentSlot = midrollSlot;
            freeWheelAds.currentSlot.play();
            freeWheelAds.midrollSlots.splice(i, 1);
            // log for missing ads
            // var missingNo = adObj.midrollsize - midrollSlot.getAdCount();
            // if (missingNo > 0) {
            //   for (var k = 0; k < missingNo; k++) {
            //     freeWheelAds.currentAdObj.adTitle =
            //       "_adError_NO_AD_CREATIVE_FOUND";
            //     freeWheelAds.logAd(
            //       false,
            //       false,
            //       "midroll",
            //       freeWheelAds.currentAdObj
            //     );
            //   }
            // }
            return;
          } else {
            Logger.printLog(
              "adlogfw",
              "FREEWHEEL ADS >>> playMidroll - NO VALID ADS FOUND AT " +
                i +
                ", slotTimePosition: " +
                slotTimePosition +
                ", midrollslots length: " +
                freeWheelAds.midrollSlots.length,
              ""
            );
            freeWheelAds.currentSlot = midrollSlot;
            // log all ad errors equal to midrollsize
            freeWheelAds.currentAdObj.adTitle = "_adError_NO_AD_CREATIVE_FOUND";
            // for(var k = 0; k < adObj.midrollsize; k++) {
            // 	freeWheelAds.logAd(false, false, 'midroll', freeWheelAds.currentAdObj);
            // }

            freeWheelAds.midrollSlots.splice(i, 1);
            freeWheelAds.currentSlot.play(); // this is done as per FW team request that each slot should be attempted
            return;
          }
        } else {
          Logger.printLog(
            "adlogfw",
            "FREEWHEEL ADS >>> no midroll break found yet",
            ""
          );
        }
      }
    },

    onAdStart: function () {
      Logger.printLog("adlogfw", "FREEWHEEL ADS >>> onAdStart called", "");
      Logger.processUserAction('adStart');
      Helper.preloaderDisplay("show");
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      fwAdHelper.showAdVideoElem();
      try{
        freeWheelAds.videoObj.showLoader();
      } catch(e){

      }

      /*if(freeWheelAds.videoObj.isPaused()) freeWheelAds.mainVideoPlayer.pause();
		freeWheelAds.videoObj.removeEventListeners();
        freeWheelAds.videoObj.vodInfo.hideDisplayInfo();
        freeWheelAds.videoObj.vodPlaylist.exitPlayerGridNavigation();
        freeWheelAds.videoObj.removeCaption();
        freeWheelAds.videoObj.resetVideoPlayer(false);*/

      freeWheelAds.adHandler.setAdState();
      /*freeWheelAds.mainVideoPlayer.removeAttribute('crossorigin');*/
      //$('.video-controls-group').hide();
    },

    onAdStop: function () {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;

      freeWheelAds.adSerialNo = 0;
      fwAdHelper.showHideAdLabel("hide");
      freeWheelAds.adHandler.resetAdState("fw");
      try {
        freeWheelAds.mainVideoPlayer.setAttribute("crossorigin", "anonymous");
      } catch (e) {}
    },

    // Step #6: Play content video
    playContent: function (setstate = true) {
      // Play video content, and add event listener to trigger when video time updates or video content ends
      const { appConfig, platform, appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let adObj = app?.adObj;
      let freeWheelAds = app?.freeWheelAds;
      fwAdHelper.clearAdVideoElem();
      Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> playContent : enableWaterfalling : fallbackRequested ',[appConfig.enableWaterfalling,' : ',freeWheelAds.fallbackRequested]);

      if(freeWheelAds.fallbackRequested){
        freeWheelAds.fallbackRequested=false;
        freeWheelAds.noAds=0;
        Logger.printLog('adlogfw', 'FREEWHEEL ADS >>> 6. freeWheelAds - noAds',[freeWheelAds.noAds]);          
        //if(appState.player.pausedTime!=0){
          if(appConfig.enableWaterfalling == true) {
            freeWheelAds.adSerialNo = 0;
            freeWheelAds.adHandler.resetAdState('fw');
            this.passControlToIma(setstate);
            return;
          }
        //}
      }
      this.handlePlayContent(setstate);
    },

    handlePlayContent: function (setstate) {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;

      if (!freeWheelAds.videoObj.isPaused()) {
        return;
      }
      this.onAdStop();
      freeWheelAds.contentState = "VIDEO_STATE_PLAYING";
      this.contentState = tv.freewheel.SDK.VIDEO_STATE_PLAYING;
      if (
        freeWheelAds.currentAdContext !== null &&
        setstate == true &&
        ((appState.player.pausedTime !== 0 &&
          appState.player.noVideosStarted == 1 &&
          !freeWheelAds.vodContentStateSet) ||
          (appState.player.pausedTime == 0 &&
            appState.player.noVideosStarted > 1))
      ) {
        freeWheelAds.currentAdContext.setVideoState(
          tv.freewheel.SDK.VIDEO_STATE_PLAYING
        );
        freeWheelAds.vodContentStateSet = true;
      }

      freeWheelAds.adHandler.hideAdVideoElem();

      if (
        appState.player.videoStartedFromResumePoint !== 0 &&
        appState.player.pausedTime == 0
      ) {
        freeWheelAds.videoObj.resumeVideoPlayback(
          appState.player.videoStartedFromResumePoint,
          "onContentResumeRequested"
        );
      } else {
        freeWheelAds.videoObj.resumeVideoPlayback(
          appState.player.pausedTime,
          "onContentResumeRequested"
        );
      }
      return;
    },





    pauseContent: function () {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      freeWheelAds.contentState = "VIDEO_STATE_PAUSED";
      freeWheelAds.videoObj.pauseContent();
      this.contentState = tv.freewheel.SDK.VIDEO_STATE_PAUSED;
      if (freeWheelAds.currentAdContext !== null)
        freeWheelAds.currentAdContext.setVideoState(
          tv.freewheel.SDK.VIDEO_STATE_PAUSED
        );
    },

    // Step #8: Play postroll advertisements when content ends
    onContentVideoEnded: function () {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;
      // Unbind the event listener for detecting when the content video ends, and play postroll if any
      if (freeWheelAds.contentState === "VIDEO_STATE_PLAYING") {
        Logger.printLog(
          "adlogfw",
          "FREEWHEEL ADS >>> onContentVideoEnded ==============content ended==============",
          ""
        );
        if (freeWheelAds.currentAdContext) {
          freeWheelAds.currentAdContext.setVideoState(
            tv.freewheel.SDK.VIDEO_STATE_COMPLETED
          );
          this.contentState = tv.freewheel.SDK.VIDEO_STATE_COMPLETED;
          this.cleanUp();
        }
      }
    },

    cleanUp: function () {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      let freeWheelAds = app?.freeWheelAds;

      // Clean up after postroll ended or content ended(no postroll)
      if (freeWheelAds.currentAdContext) {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let ads = app?.ads;
        freeWheelAds.currentAdContext.removeEventListener(
          tv.freewheel.SDK.EVENT_REQUEST_COMPLETE,
          this.onRequestComplete
        );
        freeWheelAds.currentAdContext.removeEventListener(
          tv.freewheel.SDK.EVENT_SLOT_ENDED,
          this.onSlotEnded
        );
        freeWheelAds.player = null;
        freeWheelAds.currentAdObj = {};
        freeWheelAds.appName = "";
        freeWheelAds.currentAdContext = null;
        freeWheelAds.videoDuration = 0;
        freeWheelAds.currentSlot = null;
        freeWheelAds.prerollSlots = [];
        freeWheelAds.prerollStatus = {};
        freeWheelAds.postrollSlots = [];
        freeWheelAds.midrollSlots = [];
        freeWheelAds.midrollStatus = {};
        freeWheelAds.config = null;
        freeWheelAds.videoConfig = null;
        freeWheelAds.videoInfo = null;
        ads.preRollRequestMade = false;
      }
    },
  };
}

var fwAdHelper = {
  checkIfPreRollBeRequested: function () {
    const { appConfig, platform, appState } = AppData as AppSetup;
    Logger.printLog(
      "adlogfw",
      "FREEWHEEL ADS >>> fwAdHelper.checkIfPreRollBeRequested - appState.player.noVideosStarted: ",
      appState.player.noVideosStarted
    );
    const app = appState?.getApp();
    let adObj = app?.adObj;
    let ads = app?.ads;
    if (adObj.adActivation == true) {
      if (appState.player.videoStartedFromResumePoint !== 0) {
        return;
      }

      //appState.player.noVideosStarted = 2
      if (appState.player.noVideosStarted > adObj.firstadInterval) {
        //adObj.adInterval = 1;
        if (appState.player.noVideosStarted % adObj.adInterval == 0) {
          if (ads.preRollAdsRequested < adObj.nonmidrollsize) {
            return true;
          }
        }
      }
    }
    return false;
  },

  /* @description - to hide or show the ad label
	   @param - action - whether to hide the ad label or show
	*/
  showHideAdLabel: function (action) {    
    const { appConfig, appState } = AppData as AppSetup;    
    const app = appState?.getApp();
    let freeWheelAds = app?.freeWheelAds;
    if (action == "hide") {
      $(".custom-ad-label").css("display", "none");
    } else {
      $(".custom-ad-label").css("display", "block");
      if(appConfig?.enableIMAAdPodding){
        let totalAds = Number(freeWheelAds.totalAdsInPod) + Number(app.imaAdHandler.totalAds);
        $('.custom-ad-number').text(`${freeWheelAds.adSerialNo} / ${totalAds}`);
      }
      /*fwAdHelper.updateAdLabel(
        freeWheelAds.adSerialNo,
        freeWheelAds.totalAdsInPod
      );*/
    }
  },

  updateAdLabel: function (adNumber, totalAds, txt = "") {
    if (
      adNumber !== null &&
      adNumber !== undefined &&
      totalAds !== null &&
      totalAds !== undefined
    ) {
      $(".custom-ad-label .custom-ad-number").text(
        adNumber + " of " + totalAds
      );
    } else if (txt !== "") {
      $(".custom-ad-label .custom-ad-number").text(txt);
    } else {
      $(".custom-ad-label .custom-ad-number").text("");
    }
  },

  createAdVideoElem: function () {
    if(document.getElementById('displayBase')){
      return;
    }
    var elemDiv = document.createElement("div");
    elemDiv.setAttribute("id", "displayBase");
    var elemVideo = document.createElement("VIDEO");
    elemVideo.setAttribute("id", "adVideo");
    elemDiv.style.cssText =
      "position:absolute;width:100%;height:100%;opacity:0;z-index:100;background:#000;pointer-events:none;";
    elemVideo.style.cssText =
      "height:100vh;width:100%;pointer-events:none;pointer-events:none;";
    elemDiv.appendChild(elemVideo);

    $(elemDiv).append(
      `<label class="custom-ad-label" style="bottom: 24px;vertical-align: bottom;color: #fff;background: #00000094;padding: 2px 10px;width: auto;position: absolute;left:25px;display:none;">Video will play after ads <span class="custom-ad-number"></span></label>`
    );
    document.body.appendChild(elemDiv);
  },

  removeAdVideoElem: function () {
    const element = document.getElementById("displayBase");
    $(element).css('opacity', '0');
    var elemVideo = document.getElementById("adVideo");
    elemVideo.src = "";
    elemVideo.removeAttribute('src');
  },
  clearAdVideoElem: function () {
    var elemVideo = document.getElementById("adVideo");
    elemVideo.src = "";
    elemVideo.removeAttribute('src');
  },
  showAdVideoElem: function () {
    const element = document.getElementById("displayBase");
    $(element).css('opacity', '1');
  },
};
